import React, { useId } from 'react';

export default function TextInput({
    type = "text",
    name,
    placeholder,
    label,
    defaultValue,
    onChange,
    required = false,
    hint,
    error,
    id: idProp,
}) {

    const generatedId = useId();
    const id = idProp || generatedId;
    const hintId = hint ? `${id}-hint` : undefined;
    const errorId = error ? `${id}-error` : undefined;
    const describedBy = [hintId, errorId].filter(Boolean).join(' ') || undefined;

    return (
        <div className='w-full'>
            {label && (
                <label htmlFor={id} className='text-sm mb-1 block'>
                    {label}
                    {required && <span className='text-red-600 ml-0.5' aria-hidden="true">*</span>}
                </label>
            )}
            <input
                id={id}
                type={type}
                placeholder={placeholder}
                name={name}
                defaultValue={defaultValue}
                onChange={onChange}
                required={required}
                aria-required={required || undefined}
                aria-invalid={error ? true : undefined}
                aria-describedby={describedBy}
                className={`w-full border text-sm rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow focus-visible:border-black placeholder:text-muted px-4 py-3 block transition-colors ${error ? 'border-red-600' : 'border-light focus:border-black'}`}
            />
            {hint && !error && (
                <p id={hintId} className='text-xs text-black/60 mt-1'>{hint}</p>
            )}
            {error && (
                <p id={errorId} className='text-xs text-red-600 mt-1'>{error}</p>
            )}
        </div>
    )
}
